import React from 'react';

import { ContainerHeader, TabContainer } from '~components';
import { faMoneyBill } from '~components/icon';

import Budgets from './Budgets';
import ClientsWithBudgets from './ClientsWithBudgets';

const BudgetsContainer: React.FC = () => {
  const tabs = [
    { id: 'sah-budgets', title: 'Budgets', component: Budgets },
    { id: 'sah-clients-with-budgets', title: 'Clients with Budgets', component: ClientsWithBudgets },
  ];

  return (
    <div className="p-2">
      <ContainerHeader icon={faMoneyBill} iconSize="1x" className="info" dataCy="sah-budgets-header">
        <div className="d-flex align-items-center gap-1">
          <span>Support At Home Budgets</span>
        </div>
      </ContainerHeader>
      <TabContainer tabs={tabs} />
    </div>
  );
};

export default BudgetsContainer;
